// Adapted from case-desk src/components/UiProvider.tsx (commit 1d18e32), 2026-08-03; P8 uses the theme
// factory so tenant brand colors can enter through it alone (das-web § 8.4).
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { useMemo, type ReactNode } from 'react';

import { createDasWebTheme } from '../theme/theme';
import type { BrandColorOverrides } from '../theme/tokens';

type UiProviderProps = {
  brandColors?: BrandColorOverrides;
  children: ReactNode;
};

export function UiProvider({ brandColors, children }: UiProviderProps) {
  const theme = useMemo(() => createDasWebTheme(brandColors), [brandColors]);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </ThemeProvider>
  );
}
